import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { addUserTofund } from 'services/fund'

export default function useSetAddUser() {
    const navigate = useNavigate()
    const { mutate } = useMutation({
        mutationFn: (payload: IAddNewUserToFundPayload) => {
            return addUserTofund(payload)
        },
        onSuccess: (data) => {
            toast.success('کاربر با موفقیت اضافه شد')
            navigate(-1)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
